<template>
<div >
  <!-- <v-layout row>
    <v-layout row>
      <v-flex xs6>
      &nbsp; Last Reading: {{timestamp}}
      </v-flex>
    </v-layout>
  </v-layout> -->
  <!-- Last Reading: {{timestamp}} -->
  <v-layout row wrap style="margin: '0px'; padding: '0px'; " >
    <Gauge v-for="gauge in gauges" :key="gauge.i"
    :args="gauge" :size="size" style="margin: '0px'; padding: '0px'"> 
    </Gauge>
  </v-layout>
  </div>
</template>
<script>
import axiosInstances from '@/../../coreui/server/axiosInstances'
import Gauge from './Gauge'
import ui from '@/../../coreui/helpers/ui'
// import utils from '@/../../coreui/helpers/utils'
import { sync } from 'vuex-pathify'
export default {
    components: {
      Gauge
    },
    props: ["size", "deviceID", "dt"],
    data: () => ({
      timestamp: null,
      gauges: [],
      bgColor: '#0A0A0A'
    }),
    
    computed: {
      dark: sync('misc/dark'),
      dictionary: sync('table/dictionary'),
      // comps() { return  [
      //   {
      //     args: {
      //       s:0,
      //       values: [['Label', 'Value'],['Temp', 75]],
      //       colors: ui.theme(this.dark).palette,
      //       backgroundColor: ui.theme(this.dark).backgroundcolor, 
      //       legend: {textStyle: ui.theme(this.dark).legend},
      //       vAxis: {
      //         textStyle: ui.theme(this.dark).legend
      //       },
      //       width: 200,
      //       height: 200,
      //       green: {from: 0, to: 50},
      //       red: {from: 75, to: 100},
      //       yellow: {from: 51, to: 74},
      //       titleTextStyle: ui.theme(this.dark).titlee
      //     },
      //     component: Gauge
      //   },
      //   {
      //     args: {
      //       s:1,
      //       values: [['Label', 'Value'],['Temp', 75]],
      //       colors: ui.theme(this.dark).palette,
      //       backgroundColor: ui.theme(this.dark).backgroundcolor, 
      //       legend: {textStyle: ui.theme(this.dark).legend},
      //       vAxis: {
      //         textStyle: ui.theme(this.dark).legend
      //       },
      //       width: 200,
      //       height: 200,
      //       green: {from: 0, to: 50},
      //       red: {from: 75, to: 100},
      //       yellow: {from: 51, to: 74},
      //       titleTextStyle: ui.theme(this.dark).titlee
      //     },
      //     component: Gauge
      //   },
      //   {
      //     args: {
      //       s:2,
      //       values: [['Label', 'Value'],['Temp', 75]],
      //       colors: ui.theme(this.dark).palette,
      //       backgroundColor: ui.theme(this.dark).backgroundcolor, 
      //       legend: {textStyle: ui.theme(this.dark).legend},
      //       vAxis: {
      //         textStyle: ui.theme(this.dark).legend
      //       },
      //       width: 200,
      //       height: 200,
      //       green: {from: 0, to: 50},
      //       red: {from: 75, to: 100},
      //       yellow: {from: 51, to: 74},
      //       titleTextStyle: ui.theme(this.dark).titlee
      //     },
      //     component: Gauge
      //   },
      //   {
      //     args: {
      //       s:3,
      //       values: [['Label', 'Value'],['Temp', 75]],
      //       colors: ui.theme(this.dark).palette,
      //       backgroundColor: ui.theme(this.dark).backgroundcolor, 
      //       legend: {textStyle: ui.theme(this.dark).legend},
      //       vAxis: {
      //         textStyle: ui.theme(this.dark).legend
      //       },
      //       width: 200,
      //       height: 200,
      //       green: {from: 0, to: 50},
      //       red: {from: 75, to: 100},
      //       yellow: {from: 51, to: 74},
      //       titleTextStyle: ui.theme(this.dark).titlee
      //     },
      //     component: Gauge
      //   }
      // ] 
      // },
    },
    watch: {
      deviceID: {
        immediate: true,
        handler (val) {
          this.getSensorData(val)
        }
      },
      dark: {
        immediate: true,
        handler (val) {
          this.bgColor = ui.theme(val).backgroundcolor
        }
      }
    },
    methods: {
      getDictionaryVal(code, key) {
        let val = this.dictionary.filter(i => i.code == code)
        return (val[0][key])
      },
      async getSensorData (val) {
        console.log('Sensor ID: ', val)
        let d = await axiosInstances.apiServer.get('/dt/v1/' + val + '?last=1')
        if (d == null || d.data == null) return
        let sdata = d.data[0]
        let deviceData = sdata.data
        let ks = Object.keys(deviceData) // keys of all sensor data
        this.timestamp = new Date(sdata.ts)
        this.$emit('update:dt', this.timestamp)
        let index = -1
        this.gauges = ks.map((i) => {
          index++
          return {
            i: index,
            values: [
              ['Label', 'Value'],
              [this.getDictionaryVal(ks[index], 'short') + '/' + 
              this.getDictionaryVal(ks[index], 'unit'), parseFloat(parseFloat(deviceData[ks[index]].toString()).toFixed(2))]
            ],
            green: {
              from: this.getDictionaryVal(ks[index],'low'), 
              to: this.getDictionaryVal(ks[index],'med')
            },
            red: {
              from: this.getDictionaryVal(ks[index],'warn'), 
              to: this.getDictionaryVal(ks[index],'max')
            },
            yellow: {
              from: this.getDictionaryVal(ks[index],'med'), 
              to: this.getDictionaryVal(ks[index],'warn')
            },
            range: { 
              from: this.getDictionaryVal(ks[index],'min'), 
              to: this.getDictionaryVal(ks[index],'max')
            }
          }
        })
        console.log('gauges: ', this.gauges)
      }
    },
    async mounted () {
      
    }
}
</script>
<style scoped>
svg g text {
  font-size: .7em;
}
</style>

